<template>
  <button
    type="button"
    class="auth-login__theme-toggle"
    :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
    :aria-pressed="isDark"
    @click="toggleTheme"
  >
    <AuthIcon :name="isDark ? 'sun' : 'moon'" />
  </button>
</template>

<script setup>
import AuthIcon from './AuthIcon.vue'
import { useAuthTheme } from '../composables/useAuthTheme.js'

const { isDark, toggleTheme } = useAuthTheme()
</script>
